/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * @deprecated Use `createOtlpFetchExportDelegate` instead.
 */
export { createOtlpSendBeaconExportDelegate } from './otlp-browser-http-export-delegate';

export { convertLegacyBrowserHttpOptions } from './configuration/convert-legacy-browser-http-options';
export { createLegacyOtlpBrowserExportDelegate } from './configuration/create-legacy-browser-delegate';
